<template>
  <div v-if="isProfileEmpty" class="upload-resume">
    <cv-file-upload
      :show-title="false"
      :show-empty-label="false"
      :files="resumeState.file"
      :error="resumeState.error"
      :loading="resumeState.loading"
      @on-file-attach="handleUploadResume"
      @on-file-remove="handleRemoveResume">
    </cv-file-upload>
  </div>
  <div v-else class="replace-resume">
    <div v-if="resumeState.loading" class="button is-primary-ghost-small upload-resume-loader">
      <div class="loader"></div>
    </div>
    <ghost-button-with-icon
      v-else
      :title="modalButtonTitle"
      :custom-classes="'button is-primary-ghost-small'"
      :handler="openUploadNewCVmodal">
      <svg-icon name="plus" width="16" height="16"></svg-icon>
    </ghost-button-with-icon>
    <modal-dialog-upload-resume :modal-name="uploadNewCvModal" :replace-mode="!!isResumeFileUploaded"></modal-dialog-upload-resume>
  </div>
</template>

<script>

import {omit, some} from 'lodash';
import GhostButtonWithIcon from 'top20common/components/buttons/GhostButtonWithIcon';
import CvFileUpload from 'top20common/components/file-upload/CvFileUpload';
import {mapGetters} from 'vuex';

import ModalDialogUploadResume from './ModalDialogUploadResume';

export default {
  data() {
    return {
      uploadNewCvModal: 'upload-new-cv-modal'
    };
  },
  computed: {
    ...mapGetters(['profileDetailsState', 'resumeState', 'isResumeFileUploaded']),
    isProfileEmpty() {
      return this.profileDetailsState.profile_completeness_progress <= 12 && !this.isBasicInfoChangedAfterRegisterState;
    },
    isBasicInfoChangedAfterRegisterState() {
      let afterRegisterRequired = ['email', 'full_name', 'phone_number', 'local_currency'];
      return some(omit(this.basicProfileDataState, afterRegisterRequired), field => !!field);
    },
    modalButtonTitle() {
      return this.isResumeFileUploaded ? this.labels.uploadNewCV : this.labels.uploadCV;
    },
    labels() {
      return {
        uploadCV: this.$gettext('Upload CV'),
        uploadNewCV: this.$gettext('Upload a new CV')
      };
    }
  },
  methods: {
    handleUploadResume(file) {
      this.$store
        .dispatch('uploadCandidateResumeAction', {file, parse: true})
        .then(() => {
          this.$store.dispatch('getProfileAction');
          this.$router.push({name: 'edit-basic-profile-data'});
          this.showProfileUpdateToast();
        })
        .catch(() => this.parseError());
    },
    handleRemoveResume() {
      this.$store.commit('mutateResumeState', {file: null, info: null});
    },
    parseError() {
      this.$toast.open({
        message: this.$gettext(
          "Our system couldn't read your CV file, but it's saved in case you want to keep it as an attachment."
        ),
        type: 'is-danger'
      });
    },
    openUploadNewCVmodal() {
      this.$modal.show(this.uploadNewCvModal);
    },
    showProfileUpdateToast() {
      this.$toast.open({message: this.$gettext('CV and profile updated'), type: 'is-success', duration: 3000});
    }
  },
  components: {
    CvFileUpload,
    GhostButtonWithIcon,
    ModalDialogUploadResume
  }
};
</script>

<style lang="scss" scoped>
.button {
  margin: 15px 0 0;
  width: auto;
}
/deep/ .attachments-field {
  justify-content: flex-end;
}

/deep/ .attachments-controls {
  display: none;
}

.upload-resume-loader {
  min-width: 150px;
}
</style>
